import React from 'react';
import { PixelInput } from './pixel-input';
import { useUpdateSurveyMutation } from '../../redux/survey/survey.endpoints';

interface SurveyPixelProps {
  extSurveyId: string;
  surveyTitle: string;
  initialPixel?: string;
}

export const SurveyPixel: React.FC<SurveyPixelProps> = ({ extSurveyId, surveyTitle, initialPixel }) => {
  const [updateSurvey] = useUpdateSurveyMutation();

  const handleSave = (value: string | null) => {
    updateSurvey({
      ext_survey_id: extSurveyId,
      title: surveyTitle,
      survey_pixel: value,
    });
  };

  return (
    <PixelInput
      title="Survey pixel"
      tooltipMessage="Optional. Add tracking pixel or script for this survey."
      initialPixel={initialPixel}
      onSave={handleSave}
    />
  );
};